module.exports = __webpack_public_path__ + "img/story035@2x.2b929b39.webp";